var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.quoteDistribution.id)?_c('div',[_c('quote-distribution-component',{attrs:{"quote-distribution":_vm.quoteDistribution}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }